module.exports = __webpack_public_path__ + "img/banner_delphinus@2x.c0955061.png";